// extracted by mini-css-extract-plugin
export var explainable = "_h1-a";
export var printerCard = "_h1-1";
export var printerCardConfigured = "_h1-2";
export var printerCardError = "_h1-3";
export var printerCardsContainer = "_h1-0";
export var printerIcon = "_h1-8";
export var printerIconConfigured = "_h1-5";
export var printerIconContainer = "_h1-4";
export var printerIconError = "_h1-6";
export var printerIconUnconfigured = "_h1-7";
export var workstationsTableCard = "_h1-9";